import { graphql } from "../gql";

export const getClaimPhasesQueryDoc = graphql(/* GraphQL */ `
  query getClaimPhases {
    claimPhases {
      id
      name
      description
      phase_slug
      slug
      sortOrder
      labelOrder
      stages {
        id
        name
        description
        slug
        sortOrder
        labelOrder
        who
        what
        stageDetail
      }
    }
  }
`);
